var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgClaim = function SvgClaim(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.205 3a4.72 4.72 0 0 0-3.39 1.45 5.03 5.03 0 0 0-1.405 3.5c0 1.313.505 2.572 1.405 3.5a4.72 4.72 0 0 0 3.39 1.45 4.72 4.72 0 0 0 3.39-1.45A5.03 5.03 0 0 0 21 7.95a5.03 5.03 0 0 0-1.404-3.5A4.72 4.72 0 0 0 16.206 3m0 3.15c.231 0 .453.095.617.264a.92.92 0 0 1 .255.636v1.8a.92.92 0 0 1-.255.636.86.86 0 0 1-.617.264.86.86 0 0 1-.616-.264.92.92 0 0 1-.256-.636v-1.8c0-.239.092-.468.256-.636a.86.86 0 0 1 .616-.264m-5.415 9.815c.422 0 .832-.145 1.165-.412s.571-.641.676-1.064a3.9 3.9 0 0 0-1.174-.923c-.77-.412-1.717-.666-2.444-.666-1.059 0-1.728.063-2.396.27-.465.144-.931.36-1.503.63l-.593.274a.9.9 0 0 0-.379.33.9.9 0 0 0-.142.492V20.1c0 .239.092.468.255.636a.86.86 0 0 0 .617.264h6.974c3.404 0 6.08-2.088 8.228-3.767l.154-.12c.234-.182.4-.444.47-.74a1.35 1.35 0 0 0-.092-.88c-.569-1.216-2.005-1.531-3.037-.912-1.137.68-2.267 1.105-3.618 1.296a3.7 3.7 0 0 1-1.335 1.384 3.55 3.55 0 0 1-1.826.506H8.877a.85.85 0 0 1-.617-.263.9.9 0 0 1-.255-.637.93.93 0 0 1 .255-.636.87.87 0 0 1 .617-.264h1.912z",
    clipRule: "evenodd"
  }))));
};
export default SvgClaim;